export const isElementInViewport = (el: Element) => {
  const rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
};

export const scrollIntoViewIfNeeded = (el: Element) => {
  if (!isElementInViewport(el)) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};
